import SkeletonLoader from "./skeleton_loader.js";

const ProductsLoader = ({number}) => {
    let default_num = 0;
    return new Array(number).fill(default_num + 1).map((index) => {
        default_num += 1;
        return <div className="product-card" key={default_num}>
            <div className="product-image">
                <SkeletonLoader width={'128px'} height={'130px'}/>
            </div>
            <div className="product-body">
                <div className="product-content">
                    <SkeletonLoader width={'90%'} height={'30px'}/>
                    <SkeletonLoader width={'60%'} height={'20px'}/>
                    <SkeletonLoader width={'75%'} height={'50px'}/>
                    <SkeletonLoader width={'70%'} height={'25px'}/>
                </div>
                <div className="product-footer">
                    <SkeletonLoader width={'100%'} height={'42px'}/>

                </div>
            </div>
        </div>
    })
}
export default ProductsLoader;
